<template>
    <div>
        <UploadBackgroundImage/>
    </div>
</template>

<script>
    import UploadBackgroundImage from '../parts/UploadBackgroundImage'

    export default {
        name: "ChangeRoomMenu",
        components: {UploadBackgroundImage}
    }
</script>

<style scoped>

</style>
